import { useMutation } from '@tanstack/react-query'
import { TMutationOptions } from 'common/models'
import { api } from 'services'

const logoutUser = async () => {
  return api.post('client/logout')
}

export const LOGOUT_USER_MUTATION_KEY = 'LOGOUT_USER'

export default function useLogoutUserMutation(options: TMutationOptions<unknown> = {}) {
  return useMutation({
    mutationKey: [LOGOUT_USER_MUTATION_KEY],
    mutationFn: logoutUser,
    ...options,
  })
}
